import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../../scss/pages/_newpassword.scss';
// image
import logo from "../../images/fhub_icon.png";
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';

import {
    loadingToggleAction,
    updatePasswordAction,
} from '../../store/actions/AuthActions';



const NewPassword = (props) => {


    const [password, setPassword] = useState();
    const [confirmpassword, setConfirmpassword] = useState();


    const [errors, setErrors] = useState();

    


    const dispatch = useDispatch();
 
    const handleConfirmPass = (e) => {
        e.preventDefault();

        setConfirmpassword(e.target.value);

    }
      
   

     

    function onLogin(e) {
        e.preventDefault();
       
        dispatch(loadingToggleAction(true));
    
        if (password === confirmpassword) {
            dispatch(updatePasswordAction(password, props.history));
        }

        
    }

    const history = useHistory();

    useEffect(() => {
        if (password !== confirmpassword) {
            setErrors(true);
        } else {
            setErrors(false);
        }
       
    }, [confirmpassword]);

    return (
        <div className="otp">
            <div className="card  mx-auto  login-card">
                <div className="card-body">
                    <div className="row" style={{ position: 'relative' }}>
                        <img className='img-fluid logo-img' src={logo} />
                        <p className="text-center forgotp">Please enter your new password</p>
                        <p className=" text-center no-prbp fs-5">No problem! Just provide your new password for login</p>

                        <form onSubmit={onLogin}>
                            <div className="form-group mb-3 mt-3 focus">
                                <input type="password" className="form-control"
                                    value={password} onChange={(e) => setPassword(e.target.value)}
                                />
                                <label className="mb-2 "><strong>New password</strong>  </label>
                            </div>

                            <div className="form-group mb-3 mt-3 focus">
                                <input type="password" className="form-control"
                                    value={confirmpassword} onChange={handleConfirmPass}
                                />
                                <label className="mb-2 "><strong>Confirm password</strong>  </label>
                            </div>

                            {errors && <div className="text-danger fs-12">Password and Confirm password does not match</div>}

                            <button type="submit" className={password && confirmpassword ? "forget-text d-flex justify-content-center fs-4 mt-4" : "forget-text-disable  d-flex justify-content-center fs-4 mt-4"} style={{ cursor: 'pointer' }}> <b>Login</b> </button>

                            <Link onClick={() => history.push("/login")} className="forget-text d-flex justify-content-center fs-4 mt-2" style={{ cursor: 'pointer' }}> <b> Back</b> </Link>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewPassword;
